<form [formGroup]="formGroup">
  <div>
    <div nz-row [nzGutter]="[16, 16]">
      <!-- <div nz-col nzSpan="24">
        <app-control formControlName="activated_date" [customErrorText]="errorDate"
          [controlConfig]="{title: 'service-card.date_change', type: 'date', required: true}"></app-control>
      </div> -->
      <div nz-col nzSpan="24">
        <app-control formControlName="card_no" [controlConfig]="{title: 'card.code', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="owner" [controlConfig]="{title: 'service-card.owner', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="apartment_ids" [controlConfig]="{title: 'apartment.label', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="new_card_no" [customErrorText]="errorNewCardNo"
        [controlConfig]="{title: 'service-card.new_card_no', type: 'text', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="note" [controlConfig]="{title: 'note', type: 'textarea'}"></app-control>
      </div>
    </div>
  </div>
</form>

<div *nzModalTitle class="title-modal">{{'service-card.change-card' | translate}}</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{'close' | translate}}</button>
  <button nz-button nzType="primary" (click)="onSave()">{{'save' | translate}}</button>
</div>